// TODO: Refactor to component
export default class SlickVideoCollection {
  static init() {
    let slickSlideShow, $slickComponent;
    let $slickComponents = $(".js-slick-video-collection");

    $slickComponents.each(function(index, slickComponent) {
      $slickComponent = $(slickComponent);
      slickSlideShow = parseInt($slickComponent.data("slide-show"));

      if(!slickSlideShow) {
        slickSlideShow = 5;
      }

      $slickComponent.on("init", function() {
        var slickArrowThumbnail = $(this).data("arrow-thumbnail");

        if(slickArrowThumbnail != undefined) {
          var slickArrow = $(this).find(".slick-arrow");
          var slickThumbnail = $(this).find(".slick-thumbnail");

          if(slickArrow && slickThumbnail) {
            slickArrow.css({ top: (slickThumbnail.outerHeight() - slickArrow.outerHeight()) / 2 });
          }
        }

        $slickComponent.removeClass('js-slick-video-collection');
      }).slick({
        arrows: true,
        infinite: false,
        speed: 350,
        cssEase: 'easeInOut',
        slidesToShow: slickSlideShow,
        slidesToScroll: slickSlideShow
      });
    });
  }
}
